<mat-form-field appearance="outline" class="w-full">
  <mat-label i18n>Hourly pay</mat-label>
  <mat-slide-toggle
    matSuffix
    [formControl]="automaticWage"
    i18n-matTooltip
    matTooltip="Automatically determine wage"
  ></mat-slide-toggle>
  <input
    matInput
    type="number"
    [formControl]="hourlyPay"
    data-cy="hourlyPay"
    [readonly]="automaticWage.value"
    [class.pointer-events-none]="automaticWage.value"
    [errorStateMatcher]="observableErrorState"
  />
  <mat-error>
    @if ((hourlyPay | errorChanges)?.["wageSchema"]; as wageSchemaError) {
      {{ wageSchemaError }}
    } @else {
      <span i18n>Could not determine wage</span>
    }
  </mat-error>
  <mat-hint>
    @if (hourlyPay.pristine && activeSchema(); as schema) {
      @if (target(); as target) {
        <span i18n>
          Wage according to
          <u>{{ schema }}</u>
          schema and age
          {{
            getAge
              | apply
                : staff()?.dateOfBirth
                : getTargetScheduleInterval(target).start
          }}
        </span>
      }
    }
  </mat-hint>
</mat-form-field>
